import React, { useEffect, useState } from 'react'
import DashboardLegacy from './DashboardLegacy'
import DashboardNew from './DashboardNew'
import {
  DashboardTheme,
  THEME_EVENT,
  getDashboardTheme,
  recordNavStyleOnce,
  setDashboardTheme,
} from './dashboardTheme'

const Dashboard: React.FC = () => {
  const [theme, setTheme] = useState<DashboardTheme>(getDashboardTheme)

  useEffect(() => {
    const syncTheme = () => setTheme(getDashboardTheme())
    window.addEventListener(THEME_EVENT, syncTheme)
    window.addEventListener('storage', syncTheme)
    return () => {
      window.removeEventListener(THEME_EVENT, syncTheme)
      window.removeEventListener('storage', syncTheme)
    }
  }, [])

  // Nav-style competition: count every user under the style they actually use,
  // not just the ones who click the toggle.
  useEffect(() => {
    recordNavStyleOnce(getDashboardTheme())
  }, [])

  const toggleTheme = () => {
    const nextTheme: DashboardTheme = theme === 'new' ? 'legacy' : 'new'
    setDashboardTheme(nextTheme)
    setTheme(nextTheme)
  }

  if (theme === 'legacy') {
    return <DashboardLegacy />
  }

  return <DashboardNew onToggleTheme={toggleTheme} isNewTheme={theme === 'new'} />
}

export default Dashboard
